import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Product } from 'src/app/models';
import { LanguageService, ValidatorsService } from 'src/app/services';
import { ReasonsForRejectValidator } from './reason-for-reject.validation';

@Component({
  selector: 'app-reason-for-reject',
  templateUrl: './reason-for-reject.component.html',
  styleUrls: ['./reason-for-reject.component.css']
})
export class ReasonForRejectComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  products: Product[] = [];
  file: any;
  status: any;

  @Output() updateEvent = new EventEmitter();


  form: UntypedFormGroup = this.fb.group({
    reason: [null, this.validator.reason],
    file_id: [null]
  });

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private validator: ReasonsForRejectValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit() {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }


  /**
   * 
   * @param event 
   */
  uploadedFile(event): void {

    this.file = {
      id: event.result.id,
      name: event.result.name,
      url: event.result.link
    }

    this.form.controls.file_id.setValue(this.file.id);
  }


  /**
   * 
   */
  clearFile(): void {

    this.file = null;
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }

  /**
* 
*/
  save(): void {

    let f: any = this.form.value;

    let data = {
      "reason_text": f.reason,
      "file_id": f.file_id
    }

    this.activeModal.close(data);
    this.updateEvent.emit(true);
  }


}
